import(/* webpackMode: "eager" */ "/vercel/path0/app/newlp/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/workiz/WorkizPage.tsx");
